import React from "react";
import { DataSearch } from "@appbaseio/reactivesearch";

class JewelrySize extends React.PureComponent {
  render() {
    return (
      <div className="jewelry-size form-field-wrap">
        <DataSearch
          title="Jewelry Size"
          className="form-field"
          placeholder="Start Search..."
          dataField={["Length"]}
          autosuggest={true}
          queryFormat="and"
          componentId="JewelrySize"
          iconPosition="right"
        />
      </div>
    );
  }
}

export default JewelrySize;
